export { default } from './Tick';
